/*@ngInject*/
const RuleConditionValueController = function ($rootScope, $scope, $element, $stateParams, configurationConstant, localization, ruleMediator, ruleModel, umStudioConstant, uiFormTemplateModel, configurationMediator, fieldType) {


    this.$onInit = function () {
        $element.addClass('ruleConditionValue');

        this.variableValueList = ruleModel.getVariableValueList();
        this.fieldSearchableValues = [];
        this.switchedToLiteral = false;
        this.valueType = null;
        this.showVariableName = false;
        this.fieldSearchableValueNgModel = '';

        this.leftSideFieldValueClassCodeMockEffectiveDate = new Date();

        localization.getTranslationByKey('ruleConditionValue').then((translations) => {
            this.literalValuePrompt = _.get(translations, 'literalValuePrompt');
            this.variableNamePrompt = _.get(translations, 'variableNamePrompt');
            this.variableValuePrompt = _.get(translations, 'variableValuePrompt');
            this.leftSideFieldValuePlaceholder = _.get(translations, 'leftSideFieldValuePlaceholder');

            this.getValueTypeText = function () {
                if (this.valueType) {
                    return _.get(translations, _.camelCase(this.valueType));
                }
                return null;
            };
        });

        $scope.$watch('$ctrl.defaultType', (value) => {
            if (value && (this.valueType === 'LiteralValue' || this.valueType === 'LeftSideFieldValue' || this.valueType === 'LeftSideFieldValueClassCode')) {
                this.ruleConditionValue.typeName = value;
            }
        });

        $scope.$watch('$ctrl.leftSideFieldName', (newValue, oldValue) => {
            if (newValue) {
                if (newValue !== oldValue) {
                    this.ruleConditionValue.valueString = null;
                    this.fieldSearchableValues = [];
                    this.leftSideFieldValueClassCodeMockFieldStructure = null;
                }

                this.setupClassCode(this.leftSideFormTemplateUniqueName, this.leftSideFieldName);
                this.getSearchableValues(this.leftSideFormTemplateUniqueName, this.leftSideFieldName);
            }
        });

        $scope.$watch('$ctrl.showLeftSideFieldValueOption', (newValue, oldValue) => {
            if (oldValue && !newValue && this.valueType === 'LeftSideFieldValue') {
                this.changeValueType('LiteralValue');
            }
        });

        $scope.$watch('$ctrl.showLeftSideFieldValueClassCodeOption', (newValue, oldValue) => {
            if (oldValue && !newValue && this.valueType === 'LeftSideFieldValueClassCode') {
                this.changeValueType('LiteralValue');
            }
        });

        $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, (event, item1Name, item2) => {
            let typeName = item2.typeName,
                isField = false;

            if (this.valueType === 'PropertyValue') {
                this.ruleConditionValue.objectName = item1Name;
                this.ruleConditionValue.propertyName = item2.propertyName;
                this.ruleConditionValue.objectType = _.capitalize(item1Name);
            } else {
                if (!_.isEmpty(item1Name) && !_.isEmpty(item2)) {
                    this.ruleConditionValue.formTemplateUniqueName = item1Name;
                    this.ruleConditionValue.fieldName = item2.fieldName;
                    isField = true;
                } else {
                    this.ruleConditionValue.formTemplateUniqueName = null;
                    this.ruleConditionValue.fieldName = null;
                    this.ruleConditionValue.variableName = null;
                }
            }

            this.ruleConditionValue.typeName = typeName;

            this.notifyValueChanged({ruleConditionValue: this.ruleConditionValue, type: typeName, isField: isField});

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        });

        if (!this.valueType) {
            this.determineValueType();
        }

        if (_.isEmpty(this.ruleConditionValue.formTemplateUniqueName) && _.isEmpty(this.ruleConditionValue.fieldName)) {
            this.ruleConditionValue.formTemplateUniqueName = this.defaultFormTemplateUniqueName;
            this.ruleConditionValue.fieldName = '';
        }
    };

    this.$onChanges = function (changes) {
        if (!this.valueType) {
            this.determineValueType();
        }

        if (!_.isNil(changes.showFieldValueClassCodeMultiSelectOption) &&
            !_.isNil(changes.showFieldValueClassCodeMultiSelectOption.currentValue) &&
            !_.isNil(changes.showFieldValueClassCodeMultiSelectOption.previousValue)) {
            if (this.valueType === 'LeftSideFieldValueClassCode') {
                this.setupClassCode(this.leftSideFormTemplateUniqueName, this.leftSideFieldName);
            }
        }

        if (!_.isNil(changes.showFieldValueMultiSelectOption) &&
            !_.isNil(changes.showFieldValueMultiSelectOption.currentValue) &&
            !_.isNil(changes.showFieldValueMultiSelectOption.previousValue)) {
            if (this.valueType === 'LeftSideFieldValue') {
                this.getSearchableValues(this.leftSideFormTemplateUniqueName, this.leftSideFieldName);
            }
        }
    };

    this.determineValueType = function () {
        let valueType = 'LiteralValue',
            isLiteralValue,
            valueInSearchableList,
            valueInSearchableListOrEmpty,
            listOfSelectedNames,
            listOfSelectedSearchItems,
            ruleConditionValueString;

        if (this.ruleConditionValue.objectUri) {
            if (_.lastIndexOf(this.ruleConditionValue.objectUri, '/') > 0) {
                valueType = this.ruleConditionValue.objectUri.substr(1, _.lastIndexOf(this.ruleConditionValue.objectUri, '/') - 1);
            } else {
                valueType = this.ruleConditionValue.objectUri.substr(1);
            }
        }

        isLiteralValue = valueType === 'LiteralValue';

        if (this.showFieldValueMultiSelectOption) {
            ruleConditionValueString = this.ruleConditionValue.valueString || '';
            listOfSelectedNames = ruleConditionValueString.split(',');
            listOfSelectedSearchItems = _.filter(this.fieldSearchableValues, function (item) {
                return _.indexOf(listOfSelectedNames, item.value) !== -1;
            });

            valueInSearchableList = listOfSelectedSearchItems.length > 0;
        } else {
            valueInSearchableList = _.find(this.fieldSearchableValues, (fieldSearchableValue) => {
                return fieldSearchableValue.value === this.ruleConditionValue.valueString;
            });
        }

        valueInSearchableListOrEmpty = valueInSearchableList || _.isEmpty(this.ruleConditionValue.valueString);

        if (isLiteralValue) {
            if (this.showLeftSideFieldValueOption && !_.isEmpty(this.fieldSearchableValues) && valueInSearchableListOrEmpty) {
                valueType = 'LeftSideFieldValue';
            } else if (this.shouldShowLeftSideFieldValueClassCodeOption()) {
                valueType = 'LeftSideFieldValueClassCode';
            }
        }

        this.valueType = valueType;

        return valueType;
    };

    this.changeValueType = function (newValueType) {
        this.valueType = newValueType;

        this.ruleConditionValue = ruleMediator.createConditionValue(newValueType, this.defaultType);

        this.fieldSearchableValueNgModel = '';

        if (this.leftSideFieldValueClassCodeMockFieldStructure) {
            this.leftSideFieldValueClassCodeMockFieldStructure.fieldModel = {};
        }

        this.notifyValueChanged({
            ruleConditionValue: this.ruleConditionValue,
            type: this.defaultType,
            isField: false
        });

        $rootScope.$broadcast(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED);
        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };

    this.getMode = function () {
        let mode = 'forms';

        if (this.valueType === 'PropertyValue') {
            mode = 'objects';
        }

        return mode;
    };

    this.notifyLiteralValueChanged = function () {
        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };

    this.onVariableNameChange = function () {
        $rootScope.$broadcast(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED);
        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };

    this.getVariableName = function () {
        if (this.ruleConditionValue.variableName) {
            return this.ruleConditionValue.variableName;
        }

        return this.variableValuePrompt;
    };

    this.setVariableValue = function (variableValue) {
        let isField = false;

        this.ruleConditionValue.objectUri = '/VariableValue';
        this.ruleConditionValue.variableName = variableValue.variableName;
        this.ruleConditionValue.typeName = variableValue.typeName;
        this.ruleConditionValue.variableMethod = variableValue.variableMethod;
        this.notifyValueChanged({
            ruleConditionValue: this.ruleConditionValue,
            type: variableValue.typeName,
            isField: isField
        });

        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };

    this.getFieldSearchableValueName = function () {
        let matchingName = '',
            matchingNameValue;

        if (!_.isEmpty(this.fieldSearchableValues)) {
            matchingNameValue = _.find(this.fieldSearchableValues, (fieldSearchableValue) => {
                return fieldSearchableValue.value === this.ruleConditionValue.valueString;
            });

            matchingName = matchingNameValue ? matchingNameValue.name : '';
        }

        return matchingName;
    };

    this.setFieldSearchableValue = function (fieldSearchableValue) {
        let isField = false;

        this.ruleConditionValue.objectUri = '/LiteralValue';
        this.ruleConditionValue.valueString = !_.isNil(fieldSearchableValue) ? fieldSearchableValue.value : null;
        this.ruleConditionValue.typeName = this.defaultType;
        this.fieldSearchableValueNgModel = fieldSearchableValue;

        this.notifyValueChanged({
            ruleConditionValue: this.ruleConditionValue,
            type: this.defaultType,
            isField: isField
        });

        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };

    this.handleLeftSideFieldValueClassCodeValueChange = function (classCodeValue) {
        let isField = false;

        this.ruleConditionValue.objectUri = '/LiteralValue';
        this.ruleConditionValue.valueString = !_.isEmpty(classCodeValue) ? classCodeValue : null;
        this.ruleConditionValue.typeName = this.defaultType;

        this.notifyValueChanged({
            ruleConditionValue: this.ruleConditionValue,
            type: this.defaultType,
            isField: isField
        });

        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };

    this.getSearchableValues = function (formTemplateUniqueName, fieldName) {
        this.fieldSearchableValueNgModel = null;

        ruleMediator.getSearchableValues(formTemplateUniqueName, fieldName).then((searchableValues) => {
            let selectedSearchableValueName,
                ruleConditionValueString;

            if (!_.isEmpty(searchableValues)) {
                this.fieldSearchableValues = searchableValues;

                if (this.showFieldValueMultiSelectOption) {
                    ruleConditionValueString = this.ruleConditionValue.valueString || '';
                    selectedSearchableValueName = ruleConditionValueString.split(',');

                    this.fieldSearchableValueNgModel = _.filter(this.fieldSearchableValues, function (item) {
                        return _.indexOf(selectedSearchableValueName, item.value) !== -1;
                    });
                } else {
                    selectedSearchableValueName = this.getFieldSearchableValueName();

                    this.fieldSearchableValueNgModel = _.find(this.fieldSearchableValues, function (item) {
                        return item.name === selectedSearchableValueName;
                    });
                }

                this.determineValueType();
            }
        });
    };

    this.setupClassCode = function (uiFormTemplateUniqueName, fieldName) {
        this.leftSideFieldValueClassCodeMockFieldStructure = null;

        configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(uiFormTemplateUniqueName, fieldName).then((uiField) => {
            if (uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
                this.leftSideFieldValueClassCodeMockFieldStructure = {
                    rootFormId: null,
                    parentForm: {
                        hasWriteAccess: this.canUserManageFormRules
                    },
                    uiField: uiField,
                    fieldModel: {
                        value: this.ruleConditionValue.valueString
                    },
                    dynamicProperties: {},
                    isConfigurableComponent: true
                };

                this.determineValueType();
            } else {
                this.leftSideFieldValueClassCodeMockFieldStructure = null;
            }
        });
    };

    this.shouldShowLeftSideFieldValueOption = function () {
        return this.showLeftSideFieldValueOption && !_.isEmpty(this.fieldSearchableValues);
    };

    this.shouldShowLeftSideFieldValueClassCodeOption = function () {
        return this.showLeftSideFieldValueClassCodeOption && !_.isNil(this.leftSideFieldValueClassCodeMockFieldStructure);
    };

    this.toggleShowVariableName = function () {
        this.showVariableName = !this.showVariableName;
    };

    this.handleMultiSelectFieldValueChange = function (selectedValueList) {
        const listOfSelectedItemValue = _.map(selectedValueList, function (item) {
            return item.value;
        });
        this.setFieldSearchableValue({value: listOfSelectedItemValue.toString()});
    };
};

angular.module('umCore')
    .controller('ruleConditionValueController', RuleConditionValueController);
